import { Trans, useTranslation } from 'next-i18next';
import { StrongText } from '@/components/StrongText';
import { cn } from '@/utils';
export const BlankResult = () => {
  const {
    t
  } = useTranslation(['build']);
  return <div className={cn('flex w-full flex-col items-center justify-center gap-lg bg-neutral', 'max-tablet-sm:hidden')} data-sentry-component="BlankResult" data-sentry-source-file="BlankResult.tsx">
      <img src="/assets/aiRobot.png" alt="" width={128} height={128} />
      <div className={'text-center text-heading-sm-bold text-alternative opacity-[0.72]'}>
        <Trans t={t} i18nKey={'ai.modal.description'} components={{
        Comp: <StrongText text={t('ai.resultDescription.accent')} />
      }} data-sentry-element="Trans" data-sentry-source-file="BlankResult.tsx" />
      </div>
    </div>;
};